import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import AOS from "aos";
import "aos/dist/aos.css";

import MultiplexAds from "../../Admin/Pages/MultiplexAds";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
import MachineDescription from "./MachineDescription";

export default function ProductDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const [product, setProduct] = useState(null);
  const [seller, setSeller] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);

  const [showZoom, setShowZoom] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({
    x: 50,
    y: 50,
  });

  const imageWrapperRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  useEffect(() => {
    if (product) {
      setTimeout(() => {
        AOS.refreshHard();
      }, 100);
    }
  }, [product]);

  useEffect(() => {
    const fetchMachine = async () => {
      try {
        const res = await fetch(API.LIST_MACHINES);
        const json = await res.json();

        const machines = json.data || json;

        const selected = machines.find(
          (item) => String(item.id) === String(id),
        );

        setProduct(selected || null);
      } catch (err) {
        console.log(err);
      }
    };

    fetchMachine();
  }, [id]);

  // ============================================================
  // IMAGES
  // ============================================================
  const images = product?.image
    ? product.image
        .split(",")
        .map((img) => img.trim())
        .filter(Boolean)
    : [];

  const currentImage = images[currentIndex] || "";

  const getImageUrl = (img) => {
    return `${UPLOADS.MACHINE_IMAGE}${product.user_id}/${img}`;
  };

  // ============================================================
  // FETCH SELLER
  // ============================================================
  useEffect(() => {
    if (product?.user_id) {
      fetchSeller();
    }
  }, [product]);

  const fetchSeller = async () => {
    try {
      const res = await fetch(`${API.GET_USER}&id=${product.user_id}`);

      const data = await res.json();

      setSeller(data);
    } catch (error) {
      console.log("Seller Fetch Error", error);
    }
  };

  // ============================================================
  // LOGIN USER + WISHLIST
  // ============================================================
  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    setUser(loginUser);

    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      setWishlist(savedWishlist);
    }
  }, []);

  // ============================================================
  // SYNC WISHLIST
  // ============================================================
  useEffect(() => {
    const syncWishlist = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

        setWishlist(saved);
      }
    };

    window.addEventListener("cartUpdated", syncWishlist);

    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);

      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  // ============================================================
  // OPEN SELLER TAB
  // ============================================================
  useEffect(() => {
    if (!product) return;

    if (location.state?.activeTab === "seller") {
      setTimeout(() => {
        const sellerTab = document.querySelector('[data-bs-target="#seller"]');

        if (sellerTab) {
          sellerTab.click();
        }
      }, 100);
    }
  }, [product, location]);

  const handleZoomMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    let x = ((e.clientX - rect.left) / rect.width) * 100;
    let y = ((e.clientY - rect.top) / rect.height) * 100;

    x = Math.max(0, Math.min(100, x));
    y = Math.max(0, Math.min(100, y));

    setZoomPosition({
      x,
      y,
    });
  };

  const handleZoomEnter = () => {
    setShowZoom(true);
  };

  const handleZoomLeave = () => {
    setShowZoom(false);
  };

  // ============================================================
  // WISHLIST
  // ============================================================
  const toggleLike = () => {
    if (!user) {
      alert("Please login first");
      return;
    }

    let updatedWishlist = [...wishlist];

    const exists = updatedWishlist.find((item) => item.id === product.id);

    if (exists) {
      updatedWishlist = updatedWishlist.filter(
        (item) => item.id !== product.id,
      );
    } else {
      updatedWishlist.push({
        ...product,
        type: "machine",
      });
    }

    setWishlist(updatedWishlist);

    localStorage.setItem(
      `wishlist_${user.id}`,
      JSON.stringify(updatedWishlist),
    );

    window.dispatchEvent(new Event("cartUpdated"));
  };

  // ============================================================
  // PRODUCT NOT FOUND
  // ============================================================
  if (!product) {
    return (
      <div className="container text-center mt-5">
        <h4>Product not found</h4>

        <button
          className="btn btn-primary"
          onClick={() => navigate("/machine")}
        >
          Back to Shop
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid product-page">
      <div className="row">
        {/* ======================================================
            LEFT CONTENT
        ====================================================== */}
        <div className="col-lg-12">
          {/* BACK BUTTON */}
          <div className="mb-3" data-aos="fade-right">
            <button
              className="btn btn-light back-btn"
              onClick={() => navigate(-1)}
            >
              <i className="bi bi-arrow-left"></i> Back
            </button>
          </div>

          <div className="row">
            <div className="col-md-6" data-aos="fade-right">
              <div className="product-image-section">
                {/* ==================================================
      MAIN IMAGE
  ================================================== */}

                <div
                  ref={imageWrapperRef}
                  className="product-main-image-wrapper"
                  onMouseEnter={handleZoomEnter}
                  onMouseMove={handleZoomMove}
                  onMouseLeave={handleZoomLeave}
                >
                  <img
                    src={`${getImageUrl(currentImage)}?t=${Date.now()}`}
                    className="product-main-img"
                    alt={product.machine_name}
                    draggable="false"
                  />

                  {/* ==================================================
        ZOOM LENS
    ================================================== */}

                  {showZoom && (
                    <div
                      className="zoom-hover-indicator"
                      style={{
                        left: `${zoomPosition.x}%`,
                        top: `${zoomPosition.y}%`,
                      }}
                    />
                  )}
                </div>

                {/* ==================================================
      ZOOM PREVIEW

      IMPORTANT:
      This is OUTSIDE the image wrapper.
      position: fixed is applied INLINE so no CSS
      from your other files can break the position.
  ================================================== */}

                {showZoom &&
                  currentImage &&
                  imageWrapperRef.current &&
                  (() => {
                    const rect =
                      imageWrapperRef.current.getBoundingClientRect();

                    const previewWidth = 430;
                    const gap = 20;

                    // Try to place preview at TOP-RIGHT of image
                    let left = rect.right + gap;
                    let top = rect.top;

                    // If there isn't enough space on the right,
                    // show it on the left side instead.
                    if (left + previewWidth > window.innerWidth) {
                      left = rect.left - previewWidth - gap;
                    }

                    // Keep preview inside viewport vertically
                    if (top < 10) {
                      top = 10;
                    }

                    if (top + 430 > window.innerHeight - 10) {
                      top = window.innerHeight - 430 - 10;
                    }

                    return (
                      <div
                        className="product-zoom-preview"
                        style={{
                          position: "fixed",

                          left: `${left}px`,
                          top: `0`,

                          backgroundImage: `url("${getImageUrl(currentImage)}")`,
                          backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                          backgroundSize: "250%",
                          backgroundRepeat: "no-repeat",

                          backgroundColor: "#fff",

                          border: "1px solid #ddd",
                          borderRadius: "14px",

                          boxShadow: "0 10px 35px rgba(0,0,0,0.25)",

                          pointerEvents: "none",

                          zIndex: 2147483647,

                          display: "block",
                          overflow: "hidden",
                        }}
                      />
                    );
                  })()}

                {/* ==================================================
      THUMBNAILS
  ================================================== */}

                <div className="thumbnail-wrapper">
                  {images.map((img, index) => (
                    <img
                      key={index}
                      src={`${getImageUrl(img)}?t=${Date.now()}`}
                      onClick={() => {
                        setCurrentIndex(index);

                        setZoomPosition({
                          x: 50,
                          y: 50,
                        });

                        setShowZoom(false);
                      }}
                      className={`thumbnail-img ${
                        currentIndex === index ? "active-thumb" : ""
                      }`}
                      alt="thumbnail"
                      draggable="false"
                    />
                  ))}
                </div>
              </div>

              <div className="product-card1 mt-4" data-aos="fade-up">
                <div className="d-flex justify-content-between">
                  <div>
                    <h2 className="product-title">{product.machine_name}</h2>

                    <h3 className="product-price">
                      ₹ {Number(product.price).toLocaleString("en-IN")}
                    </h3>
                  </div>

                  <button
                    className="like-btn"
                    onClick={toggleLike}
                    data-aos="zoom-in"
                    data-aos-delay="300"
                  >
                    <i
                      className={
                        wishlist.some((w) => w.id === product.id)
                          ? "bi bi-heart-fill text-danger"
                          : "bi bi-heart"
                      }
                    ></i>
                  </button>
                </div>

                <p className="product-desc">{product.description}</p>
              </div>
            </div>

            {/* ==================================================
                RIGHT DETAILS
            ================================================== */}
            <div className="col-md-6" data-aos="fade-left">
              <div className="mt-4">
                {/* TABS */}
                <ul
                  className="nav nav-tabs custom-tabs mb-2"
                  data-aos="fade-down"
                >
                  <li className="nav-item">
                    <button
                      className="nav-link active"
                      data-bs-toggle="tab"
                      data-bs-target="#info"
                    >
                      Machine Info
                    </button>
                  </li>

                  <li className="nav-item">
                    <button
                      className="nav-link"
                      data-bs-toggle="tab"
                      data-bs-target="#seller"
                    >
                      Seller Info
                    </button>
                  </li>
                </ul>

                <div className="tab-content">
                  {/* ==========================================
                      MACHINE INFO
                  ========================================== */}
                  <div className="tab-pane fade show active tab-box" id="info">
                    <table className="info-table">
                      <tbody>
                        <tr data-aos="fade-up">
                          <th>Machine Type</th>
                          <td>{product.machine_name}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Left Side Head Type</th>
                          <td>{product.left_head_type}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Right Side Head Type</th>
                          <td>{product.right_head_type}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Machine Age</th>
                          <td>{product.machine_old}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Brand</th>
                          <td>{product.brand}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Model</th>
                          <td>{product.model}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Area</th>
                          <td>{product.Area}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>No Of Heads</th>
                          <td>{product.NoOfHeads}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>No Of Needles</th>
                          <td>{product.NoOfNeedls}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Max Sewing Speed</th>
                          <td>{product.Maxsewingspeed} RPM</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Beam Body Size(MM)</th>
                          <td>{product.beamBody}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Computer Type</th>
                          <td>{product.Comtype}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Motor</th>
                          <td>{product.motor}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>USB Port</th>
                          <td>{product.usbport}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Details</th>
                          <td>{product.description}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Address</th>
                          <td>{product.location}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>City</th>
                          <td>{product.city}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>State</th>
                          <td>{product.state}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* ==========================================
                      SELLER INFO
                  ========================================== */}
                  <div className="tab-pane fade tab-box" id="seller">
                    <table className="info-table">
                      <tbody>
                        <tr data-aos="fade-up">
                          <th>Name</th>
                          <td>{product.name}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Mobile No</th>
                          <td>{product.phone}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>Address</th>
                          <td>{product.location}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>City</th>
                          <td>{product.city}</td>
                        </tr>

                        <tr data-aos="fade-up">
                          <th>State</th>
                          <td>{product.state}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HORIZONTAL ADS */}
        {/* DYNAMIC MACHINE DESCRIPTION */}
        <div className="col-12">
          <MachineDescription product={product} />
        </div>

        {/* HORIZONTAL ADS */}
        <HorizontalAds />
      </div>
    </div>
  );
}
